import {
  Backdrop,
  Card,
  CircularProgress,
  Collapse,
  Fade,
  Grid,
  Icon,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Tab,
  Tabs,
  Tooltip,
} from "@mui/material";
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";
// Kaizen Dashboard components
import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import Loading from "components/Carteles/Loading";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftInputNumber from "components/SoftInputNumberUpgrade";
import SoftTypography from "components/SoftTypography";
import { MessageManager } from "context";
import { getUproColor } from "utils/colors";
import { formatDate } from "utils/formatters";

const Row = ({ index, data, handleChange, handleDelete, dataProps, setPropsErrors }) => {
  const [selectedProp, setSelectedProp] = useState(null);
  const [error, setError] = useState({
    valid: true,
    msg: null,
  });
  useEffect(() => {
    let prop = dataProps?.find((item) => item.name === data.name);
    let validation = () => ({ valid: true, message: null });
    if (prop?.validation) {
      validation = eval(prop.validation);
    }
    setSelectedProp({
      ...prop,
      validation: validation,
    });
    if (prop?.defaultValue && !data.value) {
      handleChange(index, "value", prop.defaultValue);
    }
  }, [data.name]);

  useEffect(() => {
    if (dataProps) {
      let error = selectedProp?.validation(data.value) || { valid: true, msg: null };
      error.error = !error.valid;

      if (selectedProp?.required) {
        error.valid = false;
      }

      setError(error);
      if (!error.valid) {
        setPropsErrors((prev) => {
          if (prev.includes(index)) return prev;
          return [...prev, index];
        });
      } else {
        setPropsErrors((prev) => {
          if (!prev.includes(index)) return prev;
          return prev.filter((e) => e != index);
        });
      }
    }
  }, [data.value]);

  return (
    <SoftBox
      display="flex"
      p={2}
      gap={2}
      borderBottom="solid 1px #e9ecef"
      sx={{ width: "100%", "&:hover": { backgroundColor: "#f2f6fa" } }}
    >
      <SoftBox sx={{ width: "30%" }}>
        <Select
          variant="outlined"
          name="name"
          value={data.name || ""}
          disabled={selectedProp?.required}
          sx={{
            ".MuiInputBase-input.Mui-disabled": {
              color: "#495057 !important",
              "-webkit-text-fill-color": "#495057 !important",
            },
          }}
          onChange={(e) => handleChange(index, "name", e.target.value)}
        >
          {dataProps?.map((item, index) => (
            <MenuItem key={index} value={item.name}>
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </SoftBox>
      <SoftBox sx={{ width: "100%" }}>
        {selectedProp?.inputType === "select" ? (
          <Select
            variant="outlined"
            value={data.value || ""}
            onChange={(e) => {
              handleChange(index, "value", e.target.value);
            }}
          >
            {selectedProp?.inputProps?.options?.map((item, index) => (
              <MenuItem key={index} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        ) : (
          <Tooltip title={error?.msg || ""} open={true}>
            <SoftInput
              type={selectedProp?.inputType || "text"}
              value={data.value || ""}
              inputProps={selectedProp?.inputProps || {}}
              placeholder={
                (selectedProp?.name || "Valor") + (selectedProp?.required ? " (Requerido)" : "")
              }
              error={(data.value && !error?.valid) || false}
              onChange={(e) => {
                handleChange(index, "value", e.target.value);
              }}
            />
          </Tooltip>
        )}
      </SoftBox>
      <SoftBox sx={{ width: "max-content" }}>
        <SoftBox textAlign="right">
          <Icon
            color={selectedProp?.required ? "secondary" : "error"}
            sx={{ cursor: "pointer", verticalAlign: "middle" }}
            fontSize="medium"
            onClick={() => {
              if (!selectedProp?.required) handleDelete(index);
            }}
          >
            delete
          </Icon>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

Row.propTypes = {
  index: PropTypes.number,
  data: PropTypes.object,
  handleChange: PropTypes.func,
  handleDelete: PropTypes.func,
  setPropsErrors: PropTypes.func,
  dataProps: PropTypes.array,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "90%", md: "70%", lg: "60%" },
  p: 3,
  overflow: "auto",
};

export default function ModalProducto({
  open,
  handleClose,
  refetch,
  id,
  idSucursal,
  tipo,
  onCreate,
  sucursalOnly,
}) {
  const { handleSnackbar } = useContext(MessageManager);
  const [data, setCurrentData] = useState({});
  const [expandedInfoNutricional, setExpandedInfoNutricional] = useState(false);
  const [dataToSave, setDataToSave] = useState({});
  const setData = (newData) => {
    setCurrentData(newData);
    setDataToSave(newData);
  };
  const [errors, setErrors] = useState({});
  const [dataProps, setDataProps] = useState([]);
  const [propsErrors, setPropsErrors] = useState([]);
  const { data: unidades } = useQuery(
    gql`
      query unidades {
        unidades {
          id
          nombre
          abreviatura
        }
      }
    `
  );

  const { data: dataCategorias } = useQuery(
    gql`
      query categoriasMateriaPrima {
        categoriasMateriaPrima {
          tipoProducto
          nombre
        }
      }
    `
  );

  const [getDataPropiedades] = useLazyQuery(
    gql`
      query Propiedades($type: String) {
        props(type: $type) {
          id
          type
          name
          description
          recomendList
          inputType
          defaultValue
          required
          inputProps
          validation
        }
      }
    `,
    {
      onCompleted: (res) => {
        if (!res) return;
        setDataProps(res.props);
        let defaultProps = res.props.filter(
          (p) =>
            (p.required || p.recomendList?.includes(data?.categoria)) &&
            !data?.propiedades?.some((prop) => prop.name == p.name)
        );

        if (defaultProps.length > 0) {
          let newProps = data?.propiedades?.slice() || [];
          defaultProps.forEach((prop) => {
            newProps.push({ name: prop.name, value: prop.defaultValue || "" });
          });
          setData((prev) => ({ ...prev, propiedades: newProps }));
        }
      },
    }
  );

  let tipos = ["Material", "Consumible", "Recurso"];
  let icons = ["category", "recycling", "layers"];
  let colors = ["uproYellow", "uproGreen", "uproPink"];

  const [getData, { loading }] = useLazyQuery(
    gql`
      query getMateriaPrima($id: ID!, $idSucursal: ID) {
        materiasPrimas(filter: { id: $id }) {
          id
          codigo
          tipo
          nombre
          disabled
          categoria
          descripcion
          precio
          porcentajeUtilizable
          cantidadBaseNutricionalPorUnidad
          unidadBaseNutricional
          tipoUnidad {
            id
            nombre
            abreviatura
            multiplicador
          }
          propiedades {
            name
            value
          }
          stock(idSucursal: $idSucursal) {
            pasillo
            fila
            columna
            cantidad
            stockMinimo
          }
          updatedAt
          updatedBy {
            username
          }
          informacionNutricional {
            calorias
            grasasTotales
            carbohidratosTotales
            proteinas
            sodio
            grasasTrans
            grasasSaturadas
            fibra
            azucares
            contieneTACC
            aptoVegetarianos
            aptoVeganos
          }
        }
      }
    `,
    {
      fetchPolicy: "network-only",
      cachePolicy: "no-cache",
      onCompleted: (data) => {
        if (!data?.materiasPrimas[0]) return null;
        let materiaPrima = data?.materiasPrimas[0];
        materiaPrima = JSON.stringify(materiaPrima);
        materiaPrima = materiaPrima.replace(/"__typename":"[a-zA-Z]+",?/g, "");
        materiaPrima = JSON.parse(materiaPrima);
        setCurrentData(materiaPrima);
      },
    }
  );

  const [getLastID] = useLazyQuery(
    gql`
      query getLastID {
        materiasPrimas(order: { field: "id", order: DESC }, pagination: { limit: 1, page: 1 }) {
          id
        }
      }
    `,
    {
      fetchPolicy: "network-only",
      cachePolicy: "no-cache",
    }
  );

  const [mutate, { loading: loadingSave }] = useMutation(
    gql`
      mutation saveMateriaPrima($input: MateriaPrimaInput!) {
        saveMateriaPrima(input: $input) {
          id
        }
      }
    `,
    {
      onCompleted: (data) => {
        refetch();
        if (onCreate) {
          handleClose();
          onCreate(data.saveMateriaPrima.id);
        }
        handleSnackbar("Producto guardado correctamente", "success");
        if (!id) {
          if (tipo) setData({ tipo });
          setErrors({
            codigo: {
              message: "requerido",
              color: "secondary",
            },
            nombre: {
              message: "requerido",
              color: "secondary",
            },
            categoria: {
              message: "requerido",
              color: "secondary",
            },
          });
          document.querySelector("input[name='nombre']").focus();
        } else {
          handleClose();
        }
      },
    }
  );

  const recomendarCodigo = async () => {
    let newCodigo = null;
    if (id) {
      newCodigo = `P${id}`;
      setData((prev) => ({ ...prev, codigo: newCodigo }));
    } else {
      let lastID = await getLastID().then((res) => res.data.productos?.[0]?.id);
      lastID = parseInt(lastID || 0);
      newCodigo = `P${lastID + 1}`;
      setData((prev) => ({ ...prev, codigo: newCodigo }));
    }
    validate("codigo", newCodigo);
  };

  useEffect(() => {
    if (open) {
      if (id) {
        getData({ variables: { id, idSucursal } });
      } else {
        if (tipo) setData({ tipo });
        setErrors({
          nombre: {
            message: "requerido",
            color: "secondary",
          },
          categoria: {
            message: "requerido",
            color: "secondary",
          },
        });
        recomendarCodigo();
      }
    } else {
      setData({});
      setErrors({});
      setExpandedInfoNutricional(false);
    }
  }, [id, open, tipo]);

  useEffect(() => {
    if (data) {
      getDataPropiedades({ variables: { type: data.tipo } });
    }
  }, [data?.tipo]);

  const validate = (name, value) => {
    let error = null;
    switch (name) {
      case "codigo":
        if (!value) {
          error = {
            message: "requerido",
            color: "secondary",
          };
        }
        break;
      case "nombre":
        if (!value) {
          error = {
            message: "requerido",
            color: "secondary",
          };
        }
        break;
      case "categoria":
        if (!value) {
          error = {
            message: "requerido",
            color: "secondary",
          };
        }
        break;
      case "stockMinimo":
        if (value < 0 || value > 1000) {
          error = {
            message: "El valor debe estar entre 0 y 1000",
            color: "error",
          };
        }
        break;
      case "porcentajeUtilizable":
        if (value < 0 || value > 100) {
          error = {
            message: "El valor debe estar entre 0 y 100",
            color: "error",
          };
        }
        break;
      default:
        break;
    }
    if (error) {
      setErrors((prev) => ({ ...prev, [name]: error }));
    } else if (errors[name]) {
      let err = { ...errors };
      delete err[name];
      setErrors(err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    validate(name, value);
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleChangeStock = (e) => {
    let { name, value, type } = e.target;
    if (type == "number") value = parseInt(value) || null;
    validate(name, value);
    setData((prev) => ({ ...prev, stock: { ...prev.stock, [name]: value } }));
  };

  const handleChangePorcentaje = (e) => {
    let { name, value } = e.target;

    // Convertir a número, asegurando que no sea NaN
    let numericValue = parseInt(value);
    if (isNaN(numericValue)) numericValue = 0;

    // Guardamos el valor transformado en el estado
    let newValue = 100 - numericValue;

    // Validar y actualizar estado
    validate(name, newValue);
    setData((prev) => ({ ...prev, [name]: newValue }));
  };

  const handleSave = () => {
    let input = { ...dataToSave };
    if (id) {
      input.id = id;
    }
    if (input.stock && idSucursal) {
      input.stock.idSucursal = idSucursal;
    }
    mutate({ variables: { input: input } });
  };

  useEffect(() => {
    if (data?.categoria) {
      let recomendedProps = dataProps.filter(
        (p) =>
          p.recomendList?.includes(data?.categoria) &&
          !data?.propiedades?.some((prop) => prop.name == p.name)
      );

      if (recomendedProps.length > 0) {
        let newProps = data?.propiedades?.slice() || [];
        recomendedProps.forEach((prop) => {
          newProps.push({ name: prop.name, value: prop.defaultValue || "" });
        });
        setData((prev) => ({ ...prev, propiedades: newProps }));
      }
    }
  }, [data?.categoria]);

  useEffect(() => {
    if (data.propiedades) {
      let errors = [];
      data.propiedades.forEach((item, index) => {
        if (!item.name && !errors.includes(index)) {
          errors.push(index);
        }
      });
      setPropsErrors(errors);
    }
  }, [data?.propiedades]);

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            if (
              !(
                Object.keys(dataToSave).length < 1 ||
                Object.keys(errors).length > 0 ||
                propsErrors.length > 0 ||
                loadingSave
              )
            ) {
              handleSave();
            }
          }
        }}
      >
        <Fade in={open}>
          <Card sx={style}>
            <SoftBox display="flex" justifyContent="space-between">
              <SoftBox display="flex" gap={1}>
                <Icon sx={{ color: getUproColor(colors[tipos.indexOf(tipo)]) }} fontSize="medium">
                  {icons[tipos.indexOf(tipo)] || "layers"}
                </Icon>
                <SoftTypography variant="h6" fontWeight="bold">
                  {id ? "Editar" : "Nuevo"} {tipo} {id ? `Nº${id}` : ""}
                </SoftTypography>
              </SoftBox>
              <SoftBox display="flex" alignItems="center" gap={1}>
                <Tooltip placement="top" title="Guardar cambios">
                  <SoftButton
                    variant="gradient"
                    color="success"
                    iconOnly
                    circular
                    disabled={
                      loadingSave ||
                      Object.keys(dataToSave).length < 1 ||
                      Object.keys(errors).length > 0 ||
                      propsErrors.length > 0 ||
                      loadingSave ||
                      // Si hay propiedades requeridas y en dataToSave no tienen valor
                      (dataProps.filter((p) => p.required).length > 0 &&
                        dataProps
                          .filter((p) => p.required)
                          .some(
                            (p) =>
                              !dataToSave.propiedades?.some(
                                (prop) => prop.name == p.name && prop.value
                              )
                          ))
                    }
                    onClick={handleSave}
                  >
                    {loadingSave ? (
                      <CircularProgress size={15} color="white" />
                    ) : (
                      <Icon sx={{ fontWeight: "light" }}>save</Icon>
                    )}
                  </SoftButton>
                </Tooltip>
                <Tooltip placement="top" title="Cerrar">
                  <SoftButton
                    variant="gradient"
                    color="error"
                    iconOnly
                    circular
                    onClick={handleClose}
                  >
                    <Icon sx={{ fontWeight: "regular" }}>close</Icon>
                  </SoftButton>
                </Tooltip>
              </SoftBox>
            </SoftBox>
            <SoftBox
              pt={1}
              display="flex"
              justifyContent="space-between"
              sx={{
                zIndex: 1,
              }}
            >
              <SoftTypography component="label" variant="caption" color="secondary">
                (*) Campos obligatorios
              </SoftTypography>
              {data?.updatedAt && (
                <Tooltip title={formatDate(data?.updatedAt, "dd/MM/yyyy a las hh:mm")}>
                  <SoftTypography
                    component="label"
                    variant="caption"
                    color="secondary"
                    sx={{ cursor: "pointer" }}
                  >
                    Modificado {formatDate(data?.updatedAt, "XXXX")} por{" "}
                    {data?.updatedBy?.username || "un administrador"}
                  </SoftTypography>
                </Tooltip>
              )}
            </SoftBox>
            <SoftBox>
              {loading ? (
                <Loading />
              ) : (
                <Grid container spacing={2}>
                  <Grid item xs={12} md={8}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <InputLabel htmlFor="nombre">
                          <SoftTypography component="label" variant="caption" fontWeight="bold">
                            Nombre
                          </SoftTypography>
                          <SoftTypography
                            pl={0.5}
                            component="label"
                            variant="caption"
                            color="secondary"
                          >
                            (*)
                          </SoftTypography>
                        </InputLabel>
                        <SoftInput
                          name="nombre"
                          value={data?.nombre || ""}
                          disabled={sucursalOnly}
                          onChange={handleChange}
                          placeholder="Nombre"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                          <InputLabel htmlFor="codigo">
                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                              Código
                            </SoftTypography>
                            <SoftTypography
                              pl={0.5}
                              component="label"
                              variant="caption"
                              color="secondary"
                            >
                              (*)
                            </SoftTypography>
                          </InputLabel>
                          {open && !data?.codigo ? (
                            <Tooltip title="Recomendar código" placement="top">
                              <Icon
                                sx={{ cursor: "pointer" }}
                                color="primary"
                                fontSize="small"
                                onClick={recomendarCodigo}
                              >
                                auto_awesome
                              </Icon>
                            </Tooltip>
                          ) : null}
                        </SoftBox>
                        <SoftInput
                          name="codigo"
                          value={data?.codigo || ""}
                          disabled={sucursalOnly}
                          onChange={handleChange}
                          placeholder="Código"
                          inputProps={{ maxLength: 20 }}
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <InputLabel htmlFor="precio">
                          <SoftTypography component="label" variant="caption" fontWeight="bold">
                            Precio
                          </SoftTypography>
                        </InputLabel>
                        <SoftInputNumber
                          placeholder="Precio"
                          name="precio"
                          disabled={sucursalOnly}
                          value={data?.precio || null}
                          error={data?.precio < 0}
                          onChange={handleChange}
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <InputLabel htmlFor="tipoUnidad">
                          <SoftTypography component="label" variant="caption" fontWeight="bold">
                            Tipo de unidad
                          </SoftTypography>
                        </InputLabel>
                        <Select
                          name="idTipoUnidad"
                          disabled={sucursalOnly}
                          value={data?.idTipoUnidad || data?.tipoUnidad?.id || -1}
                          onChange={handleChange}
                        >
                          {!data?.idTipoUnidad && !data?.tipoUnidad?.id && (
                            <MenuItem value={-1} disabled>
                              Seleccionar
                            </MenuItem>
                          )}
                          {unidades?.unidades?.map((item, index) => (
                            <MenuItem key={index} value={item.id}>
                              {`${item.nombre} (${item.abreviatura})`}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>

                      <Grid item xs={12}>
                        <InputLabel htmlFor="categoria">
                          <SoftTypography component="label" variant="caption" fontWeight="bold">
                            Rubro
                          </SoftTypography>
                          <SoftTypography
                            pl={0.5}
                            component="label"
                            variant="caption"
                            color="secondary"
                          >
                            (*)
                          </SoftTypography>
                        </InputLabel>
                        <Select
                          variant="outlined"
                          name="categoria"
                          disabled={sucursalOnly}
                          value={data?.categoria || ""}
                          onChange={handleChange}
                        >
                          {dataCategorias?.categoriasMateriaPrima
                            ?.filter((c) => c.tipoProducto == tipo || c.tipoProducto == null)
                            .map((item, index) => (
                              <MenuItem key={index} value={item.nombre}>
                                {item.nombre}
                              </MenuItem>
                            ))}
                        </Select>
                      </Grid>
                      <Grid item xs={12}>
                        <InputLabel htmlFor="descripcion">
                          <SoftTypography component="label" variant="caption" fontWeight="bold">
                            Descripción
                          </SoftTypography>
                        </InputLabel>
                        <SoftInput
                          name="descripcion"
                          disabled={sucursalOnly}
                          value={data?.descripcion || ""}
                          onChange={handleChange}
                          multiline
                          rows={3}
                          placeholder="Descripción"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <SoftBox height="100%" bgColor="grey-100" borderRadius="lg" p={2}>
                      <SoftTypography
                        variant="h6"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Icon fontSize="small">warehouse</Icon>&nbsp;&nbsp;En esta sucursal
                      </SoftTypography>
                      <SoftBox display="flex" gap={2} justifyContent="space-between">
                        <SoftBox>
                          <SoftBox pt={1}>
                            <SoftTypography variant="caption" color="secondary">
                              Stock actual
                            </SoftTypography>
                          </SoftBox>
                          <SoftBox>
                            <SoftBox display="flex" alignItems="center" gap={1}>
                              <SoftTypography variant="h4" fontWeight="bold">
                                {`${data?.stock?.cantidad / data?.tipoUnidad?.multiplicador || 0}${
                                  data?.tipoUnidad?.abreviatura || ""
                                }`}
                              </SoftTypography>
                            </SoftBox>
                          </SoftBox>
                        </SoftBox>
                        <SoftBox>
                          <SoftBox pt={1}>
                            <SoftTypography variant="caption" color="secondary">
                              Stock utilizable
                            </SoftTypography>
                          </SoftBox>
                          <SoftBox>
                            <SoftBox display="flex" alignItems="center" gap={1}>
                              <SoftTypography variant="h4" fontWeight="bold">
                                {`${
                                  parseInt(
                                    (data?.stock?.cantidad * data?.porcentajeUtilizable) / 100
                                  ) / data?.tipoUnidad?.multiplicador || 0
                                }${data?.tipoUnidad?.abreviatura || ""}`}
                              </SoftTypography>
                            </SoftBox>
                          </SoftBox>
                        </SoftBox>
                        <SoftBox>
                          <SoftBox pt={1}>
                            <SoftTypography variant="caption" color="secondary">
                              Desechos
                            </SoftTypography>
                          </SoftBox>
                          <SoftBox>
                            <SoftBox display="flex" alignItems="center" gap={1}>
                              <SoftTypography variant="h4" fontWeight="bold">
                                {`${
                                  (data?.stock?.cantidad -
                                    parseInt(
                                      (data?.stock?.cantidad * data?.porcentajeUtilizable) / 100
                                    )) /
                                    data?.tipoUnidad?.multiplicador || 0
                                }${data?.tipoUnidad?.abreviatura || ""}`}
                              </SoftTypography>
                            </SoftBox>
                          </SoftBox>
                        </SoftBox>
                      </SoftBox>
                      <SoftBox pt={1}>
                        <SoftTypography variant="caption" color="secondary">
                          Stock mínimo
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput
                        type="number"
                        name="stockMinimo"
                        icon={{ component: "warehouse", direction: "right" }}
                        value={data?.stock?.stockMinimo || ""}
                        inputProps={{ min: 0, max: 1000 }}
                        onChange={handleChangeStock}
                      />
                      <SoftBox pt={1}>
                        <SoftTypography variant="caption" color="secondary">
                          Porcentaje desechos
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput
                        type="number"
                        name="porcentajeUtilizable"
                        icon={{ component: "percent", direction: "right" }}
                        value={100 - (data?.porcentajeUtilizable || 0)} // Mostrar el valor ajustado
                        inputProps={{ min: 0, max: 100 }}
                        onChange={handleChangePorcentaje}
                      />
                    </SoftBox>
                  </Grid>
                  {tipo == "Consumible" && (
                    <Grid item xs={12}>
                      <Card
                        sx={{
                          border: "1px solid rgba(0, 0, 0, 0.12)",
                        }}
                      >
                        <SoftBox
                          display="flex"
                          justifyContent="space-between"
                          px={2}
                          py={1}
                          sx={{
                            borderBottom: !expandedInfoNutricional
                              ? "none"
                              : "1px solid rgba(0, 0, 0, 0.12)",
                            cursor: "pointer",
                            "&:hover": {
                              backgroundColor: "rgba(0, 0, 0, 0.04)",
                            },
                          }}
                          onClick={() => setExpandedInfoNutricional(!expandedInfoNutricional)}
                        >
                          <SoftBox display="flex" alignItems="center">
                            <SoftBox mr={1} display="flex" alignItems="center">
                              <Icon
                                sx={{
                                  color: getUproColor("uproGreen"),
                                }}
                              >
                                category
                              </Icon>
                            </SoftBox>
                            <SoftTypography variant="h6" fontWeight="bold">
                              Información nutricional
                            </SoftTypography>
                          </SoftBox>
                          <SoftBox>
                            <Tooltip
                              title={expandedInfoNutricional ? "Ocultar" : "Mostrar"}
                              placement="top"
                            >
                              <SoftButton
                                color="primary"
                                circular
                                iconOnly
                                onClick={() => setExpandedInfoNutricional(!expandedInfoNutricional)}
                              >
                                <Icon
                                  sx={{
                                    rotate: expandedInfoNutricional ? "180deg" : "0deg",
                                    transition: "all 0.5s",
                                  }}
                                >
                                  expand_more
                                </Icon>
                              </SoftButton>
                            </Tooltip>
                          </SoftBox>
                        </SoftBox>
                        <Collapse in={expandedInfoNutricional}>
                          {false ? (
                            <Loading />
                          ) : (
                            <SoftBox p={2}>
                              <SoftBox>
                                <SoftTypography variant="caption">
                                  *Información nutricional por cada 100g o 100ml de producto
                                </SoftTypography>
                              </SoftBox>
                              {Number(data?.idTipoUnidad || data?.tipoUnidad?.id) === 1 && (
                                <Grid container spacing={2} mt={0.5} mb={1}>
                                  <Grid item sm={6} xs={12}>
                                    <InputLabel htmlFor="cantidadBaseNutricionalPorUnidad">
                                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                                        Equivalencia nutricional por unidad
                                      </SoftTypography>
                                    </InputLabel>
                                    <SoftInputNumber
                                      name="cantidadBaseNutricionalPorUnidad"
                                      value={data?.cantidadBaseNutricionalPorUnidad ?? ""}
                                      error={
                                        data?.cantidadBaseNutricionalPorUnidad !== undefined &&
                                        data?.cantidadBaseNutricionalPorUnidad !== null &&
                                        Number(data.cantidadBaseNutricionalPorUnidad) <= 0
                                      }
                                      onChange={handleChange}
                                      placeholder="Cantidad neta por unidad"
                                    />
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <InputLabel htmlFor="unidadBaseNutricional">
                                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                                        Unidad de la equivalencia
                                      </SoftTypography>
                                    </InputLabel>
                                    <Select
                                      name="unidadBaseNutricional"
                                      value={data?.unidadBaseNutricional || ""}
                                      onChange={handleChange}
                                      fullWidth
                                    >
                                      <MenuItem value="" disabled>Seleccionar</MenuItem>
                                      <MenuItem value="GRAMOS">Gramos (g)</MenuItem>
                                      <MenuItem value="MILILITROS">Mililitros (ml)</MenuItem>
                                    </Select>
                                  </Grid>
                                </Grid>
                              )}
                              <Grid container spacing={2}>
                                <Grid item sm={3} xs={12}>
                                  <InputLabel htmlFor="calorias">
                                    <SoftTypography
                                      component="label"
                                      variant="caption"
                                      fontWeight="bold"
                                    >
                                      Calorías &nbsp;
                                      <SoftTypography variant="caption">(Kcal)</SoftTypography>
                                    </SoftTypography>
                                  </InputLabel>
                                  <SoftInputNumber
                                    name="calorias"
                                    value={data?.informacionNutricional?.calorias || ""}
                                    error={data?.calorias < 0}
                                    onChange={(e) => {
                                      setData((prev) => ({
                                        ...prev,
                                        informacionNutricional: {
                                          ...prev.informacionNutricional,
                                          calorias: e.target.value,
                                        },
                                      }));
                                    }}
                                    placeholder="Calorías (Kcal)"
                                  />
                                </Grid>
                                <Grid item sm={3} xs={12}>
                                  <InputLabel htmlFor="grasasTotales">
                                    <SoftTypography
                                      component="label"
                                      variant="caption"
                                      fontWeight="bold"
                                    >
                                      Grasas totales &nbsp;
                                      <SoftTypography variant="caption">(g)</SoftTypography>
                                    </SoftTypography>
                                  </InputLabel>
                                  <SoftInputNumber
                                    name="grasasTotales"
                                    value={data?.informacionNutricional?.grasasTotales || ""}
                                    error={data?.grasasTotales < 0}
                                    onChange={(e) => {
                                      setData((prev) => ({
                                        ...prev,
                                        informacionNutricional: {
                                          ...prev.informacionNutricional,
                                          grasasTotales: e.target.value,
                                        },
                                      }));
                                    }}
                                    placeholder="Grasas totales (g)"
                                  />
                                </Grid>
                                <Grid item sm={3} xs={12}>
                                  <InputLabel htmlFor="carbohidratosTotales">
                                    <SoftTypography
                                      component="label"
                                      variant="caption"
                                      fontWeight="bold"
                                    >
                                      Carbohidratos totales &nbsp;
                                      <SoftTypography variant="caption">(g)</SoftTypography>
                                    </SoftTypography>
                                  </InputLabel>
                                  <SoftInputNumber
                                    name="carbohidratosTotales"
                                    value={data?.informacionNutricional?.carbohidratosTotales || ""}
                                    error={data?.carbohidratosTotales < 0}
                                    onChange={(e) => {
                                      setData((prev) => ({
                                        ...prev,
                                        informacionNutricional: {
                                          ...prev.informacionNutricional,
                                          carbohidratosTotales: e.target.value,
                                        },
                                      }));
                                    }}
                                    placeholder="Carbohidratos totales (g)"
                                  />
                                </Grid>
                                <Grid item sm={3} xs={12}>
                                  <InputLabel htmlFor="proteinas">
                                    <SoftTypography
                                      component="label"
                                      variant="caption"
                                      fontWeight="bold"
                                    >
                                      Proteínas &nbsp;
                                      <SoftTypography variant="caption">(g)</SoftTypography>
                                    </SoftTypography>
                                  </InputLabel>
                                  <SoftInputNumber
                                    name="proteinas"
                                    value={data?.informacionNutricional?.proteinas || ""}
                                    error={data?.proteinas < 0}
                                    onChange={(e) => {
                                      setData((prev) => ({
                                        ...prev,
                                        informacionNutricional: {
                                          ...prev.informacionNutricional,
                                          proteinas: e.target.value,
                                        },
                                      }));
                                    }}
                                    placeholder="Proteínas (g)"
                                  />
                                </Grid>
                                <Grid item sm={3} xs={12}>
                                  <InputLabel htmlFor="sodio">
                                    <SoftTypography
                                      component="label"
                                      variant="caption"
                                      fontWeight="bold"
                                    >
                                      Sodio &nbsp;
                                      <SoftTypography variant="caption">(mg)</SoftTypography>
                                    </SoftTypography>
                                  </InputLabel>
                                  <SoftInputNumber
                                    name="sodio"
                                    value={data?.informacionNutricional?.sodio || ""}
                                    error={data?.sodio < 0}
                                    onChange={(e) => {
                                      setData((prev) => ({
                                        ...prev,
                                        informacionNutricional: {
                                          ...prev.informacionNutricional,
                                          sodio: e.target.value,
                                        },
                                      }));
                                    }}
                                    placeholder="Sodio (mg)"
                                  />
                                </Grid>
                                <Grid item sm={3} xs={12}>
                                  <InputLabel htmlFor="grasasTrans">
                                    <SoftTypography
                                      component="label"
                                      variant="caption"
                                      fontWeight="bold"
                                    >
                                      Grasas trans &nbsp;
                                      <SoftTypography variant="caption">(g)</SoftTypography>
                                    </SoftTypography>
                                  </InputLabel>
                                  <SoftInputNumber
                                    name="grasasTrans"
                                    value={data?.informacionNutricional?.grasasTrans || ""}
                                    error={data?.grasasTrans < 0}
                                    onChange={(e) => {
                                      setData((prev) => ({
                                        ...prev,
                                        informacionNutricional: {
                                          ...prev.informacionNutricional,
                                          grasasTrans: e.target.value,
                                        },
                                      }));
                                    }}
                                    placeholder="Grasas Trans (g)"
                                  />
                                </Grid>
                                <Grid item sm={3} xs={12}>
                                  <InputLabel htmlFor="grasasSaturadas">
                                    <SoftTypography
                                      component="label"
                                      variant="caption"
                                      fontWeight="bold"
                                    >
                                      Grasas saturadas &nbsp;
                                      <SoftTypography variant="caption">(g)</SoftTypography>
                                    </SoftTypography>
                                  </InputLabel>
                                  <SoftInputNumber
                                    name="grasasSaturadas"
                                    value={data?.informacionNutricional?.grasasSaturadas || ""}
                                    error={data?.grasasSaturadas < 0}
                                    onChange={(e) => {
                                      setData((prev) => ({
                                        ...prev,
                                        informacionNutricional: {
                                          ...prev.informacionNutricional,
                                          grasasSaturadas: e.target.value,
                                        },
                                      }));
                                    }}
                                    placeholder="Grasas saturadas (g)"
                                  />
                                </Grid>
                                <Grid item sm={3} xs={12}>
                                  <InputLabel htmlFor="fibra">
                                    <SoftTypography
                                      component="label"
                                      variant="caption"
                                      fontWeight="bold"
                                    >
                                      Fibra &nbsp;
                                      <SoftTypography variant="caption">(g)</SoftTypography>
                                    </SoftTypography>
                                  </InputLabel>
                                  <SoftInputNumber
                                    name="fibra"
                                    value={data?.informacionNutricional?.fibra || ""}
                                    error={data?.fibra < 0}
                                    onChange={(e) => {
                                      setData((prev) => ({
                                        ...prev,
                                        informacionNutricional: {
                                          ...prev.informacionNutricional,
                                          fibra: e.target.value,
                                        },
                                      }));
                                    }}
                                    placeholder="Fibra (g)"
                                  />
                                </Grid>
                                <Grid item sm={3} xs={12}>
                                  <InputLabel htmlFor="azucares">
                                    <SoftTypography
                                      component="label"
                                      variant="caption"
                                      fontWeight="bold"
                                    >
                                      Azúcares &nbsp;
                                      <SoftTypography variant="caption">(g)</SoftTypography>
                                    </SoftTypography>
                                  </InputLabel>
                                  <SoftInputNumber
                                    name="azucares"
                                    value={data?.informacionNutricional?.azucares || ""}
                                    error={data?.azucares < 0}
                                    onChange={(e) => {
                                      setData((prev) => ({
                                        ...prev,
                                        informacionNutricional: {
                                          ...prev.informacionNutricional,
                                          azucares: e.target.value,
                                        },
                                      }));
                                    }}
                                    placeholder="Azúcares (g)"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                  <InputLabel htmlFor="contieneTacc">
                                    <SoftTypography
                                      component="label"
                                      variant="caption"
                                      fontWeight="bold"
                                    >
                                      Contiene TACC
                                    </SoftTypography>
                                  </InputLabel>
                                  <Tabs
                                    value={data?.informacionNutricional?.contieneTACC ? 1 : 0}
                                    name="contieneTacc"
                                    onChange={(e, value) => {
                                      setData((prev) => ({
                                        ...prev,
                                        informacionNutricional: {
                                          ...prev.informacionNutricional,
                                          contieneTACC: value === 1,
                                        },
                                      }));
                                    }}
                                  >
                                    <Tab
                                      label={
                                        <SoftTypography
                                          variant="h6"
                                          fontWeight={
                                            !data?.informacionNutricional?.contieneTACC
                                              ? "bold"
                                              : "regular"
                                          }
                                        >
                                          No
                                        </SoftTypography>
                                      }
                                      value={0}
                                    />
                                    <Tab
                                      label={
                                        <SoftTypography
                                          variant="h6"
                                          fontWeight={
                                            data?.informacionNutricional?.contieneTACC
                                              ? "bold"
                                              : "regular"
                                          }
                                        >
                                          Si
                                        </SoftTypography>
                                      }
                                      value={1}
                                    />
                                  </Tabs>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                  <InputLabel htmlFor="aptoVegetarianos">
                                    <SoftTypography
                                      component="label"
                                      variant="caption"
                                      fontWeight="bold"
                                    >
                                      Es apto para vegetarianos
                                    </SoftTypography>
                                  </InputLabel>
                                  <Tabs
                                    value={data?.informacionNutricional?.aptoVegetarianos ? 1 : 0}
                                    name="contieneTacc"
                                    onChange={(e, value) => {
                                      setData((prev) => ({
                                        ...prev,
                                        informacionNutricional: {
                                          ...prev.informacionNutricional,
                                          aptoVegetarianos: value === 1,
                                        },
                                      }));
                                    }}
                                  >
                                    <Tab
                                      label={
                                        <SoftTypography
                                          variant="h6"
                                          fontWeight={
                                            !data?.informacionNutricional?.aptoVegetarianos
                                              ? "bold"
                                              : "regular"
                                          }
                                        >
                                          No
                                        </SoftTypography>
                                      }
                                      value={0}
                                    />
                                    <Tab
                                      label={
                                        <SoftTypography
                                          variant="h6"
                                          fontWeight={
                                            data?.informacionNutricional?.aptoVegetarianos
                                              ? "bold"
                                              : "regular"
                                          }
                                        >
                                          Si
                                        </SoftTypography>
                                      }
                                      value={1}
                                    />
                                  </Tabs>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                  <InputLabel htmlFor="aptoVeganos">
                                    <SoftTypography
                                      component="label"
                                      variant="caption"
                                      fontWeight="bold"
                                    >
                                      Es apto para veganos
                                    </SoftTypography>
                                  </InputLabel>
                                  <Tabs
                                    value={data?.informacionNutricional?.aptoVeganos ? 1 : 0}
                                    name="contieneTacc"
                                    onChange={(e, value) => {
                                      setData((prev) => ({
                                        ...prev,
                                        informacionNutricional: {
                                          ...prev.informacionNutricional,
                                          aptoVeganos: value === 1,
                                        },
                                      }));
                                    }}
                                  >
                                    <Tab
                                      label={
                                        <SoftTypography
                                          variant="h6"
                                          fontWeight={
                                            !data?.informacionNutricional?.aptoVeganos
                                              ? "bold"
                                              : "regular"
                                          }
                                        >
                                          No
                                        </SoftTypography>
                                      }
                                      value={0}
                                    />
                                    <Tab
                                      label={
                                        <SoftTypography
                                          variant="h6"
                                          fontWeight={
                                            data?.informacionNutricional?.aptoVeganos
                                              ? "bold"
                                              : "regular"
                                          }
                                        >
                                          Si
                                        </SoftTypography>
                                      }
                                      value={1}
                                    />
                                  </Tabs>
                                </Grid>
                              </Grid>
                            </SoftBox>
                          )}
                        </Collapse>
                      </Card>
                    </Grid>
                  )}
                </Grid>
              )}
            </SoftBox>
          </Card>
        </Fade>
      </Modal>
    </>
  );
}

ModalProducto.defaultProps = {
  sucursalOnly: false,
};

ModalProducto.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  refetch: PropTypes.func,
  id: PropTypes.string,
  idSucursal: PropTypes.string,
  tipo: PropTypes.oneOf(["Material", "Consumible", "Recurso"]),
  onCreate: PropTypes.func,
  sucursalOnly: PropTypes.bool,
};
